import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yz-loading-more',
  templateUrl: './yz-loading-more.component.html',
  styleUrls: ['./yz-loading-more.component.less']
})
export class YzLoadingMoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
